import initPDPProductConfiguration from '../../force-app/main/default/staticresources/B2C_PDPProductConfigurationJS.js';
initPDPProductConfiguration();

import initPDPTabbedContent from '../../force-app/main/default/staticresources/B2C_PDPTabbedContentJS.js';
initPDPTabbedContent();

import initRelatedProductsTile from '../../force-app/main/default/staticresources/B2C_RelatedProductsTileJS.js';
initRelatedProductsTile();

import initFrequentlyBoughtTogether from '../../force-app/main/default/staticresources/B2C_FrequentlyBoughtTogetherJS.js';
initFrequentlyBoughtTogether();

import initPDPTab from '../../force-app/main/default/staticresources/B2C_PDPTabJS.js';
initPDPTab();

import initPDPFeaturesAndOptions from '../../force-app/main/default/staticresources/B2C_PDPFeaturesAndOptions.js';
initPDPFeaturesAndOptions();

import initPDPJS from '../../force-app/main/default/staticresources/B2C_PDPJS.js';
initPDPJS();
